import React from 'react';
import { Container, Typography, Box, Grid, Avatar, useMediaQuery, CircularProgress } from '@mui/material';
import Banner from "../components/Banner";
import { useState, useEffect } from 'react';
import MetodoCircularMUI from '../components/MetodoCircular';
import CarouselArticulos from './../components/CarouselArticulos';
import { useTheme } from '@mui/material/styles';
import CarouselUs from './../components/CarouselUs'
import { fetchAllBlogPosts } from './../components/wordpressUtils';
import { Helmet } from 'react-helmet';

export default function Nosotros() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [index, setIndex] = useState(0);
  const [isLoadingArticles, setIsLoadingArticles] = useState(true);
  const [wordpressArticles, setWordpressArticles] = useState([]);
  const frases = [
    {
      texto: "Multidisciplinarios",
      imagen: "https://res.cloudinary.com/dhoyyqszi/image/upload/v1749060841/ebm/copie-el-espacio-publicitario-en-blanco-del-espacio_1_wvl12m.png",
    },
    {
      texto: "Estrategas",
      imagen: "https://res.cloudinary.com/dhoyyqszi/image/upload/v1750193495/ebm/estrategas_odimnl.png",
    },
    {
      texto: "Orientados a resultados",
      imagen: "https://res.cloudinary.com/dhoyyqszi/image/upload/v1745945280/ebm/img-orientado_jp0fau.png",
    },
    {
      texto: "Comprometidos",
      imagen: "https://res.cloudinary.com/dhoyyqszi/image/upload/v1745945281/ebm/img-compromiso_pxfpo2.png",
    },
    {
      texto: "Socios en el éxito",
      imagen: "https://res.cloudinary.com/dhoyyqszi/image/upload/v1750193515/ebm/sociosDelExito_hbcxum.png",
    },
  ];

  const equipo = [
    { nombre: 'Fernanda Sesma', titulo: 'L.D. | M.C.C. | C.P.L.D. | M.D.C.', img: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1750189843/ebm/FernandaSesma_anc4hi.png' },
    { nombre: 'Oscar Pacheco', titulo: 'L.D. | M.D.C.', img: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1750189845/ebm/OscarPacheco_ckaff9.png' }
  ];


  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % frases.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [frases.length]);

 useEffect(() => {
     const fetchData = async () => {
       try {
         setIsLoadingArticles(true);
         const wpArticles = await fetchAllBlogPosts();
         setWordpressArticles(wpArticles);
       } catch (err) {
         console.error('Error al obtener artículos:', err);
       } finally {
         setIsLoadingArticles(false);
       }
     };
     
     fetchData();
   }, []);

  return (

     <>
    <Helmet>
      <title>Nosotros | EBM Consultores</title>
      <meta
        name="description"
        content="Consultoría especializada en Empresa Familiar, Gobierno Corporativo y Legado Patrimonial. Descubre cómo acompañamos tu evolución."
      />
    </Helmet>

    <Container sx={{ margin: '0', padding: '0 !important', maxWidth: '100vw !important' }}>
      <Banner
        backgroundImage="https://res.cloudinary.com/dhoyyqszi/image/upload/v1745945280/ebm/banner-nosotros_cgjkpl.png"
        title={<Typography
          sx={{
            fontSize: { xs: '24px', sm: '38px', md: '46px' }, lineHeight: 1.2,
            position: 'relative',
            px: '2vw',
            borderRadius: '50rem',
            background: 'linear-gradient( rgba(10, 98, 116, 0), rgba(10, 98, 116, 0.5))',
            color: 'white',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)',
            boxShadow: '0px 2px 10px rgba(0,0,0,0.5)',
            transition: 'box-shadow 0.3s ease, border-color 0.3s ease',
            fontWeight: 500,
            zIndex: 1,
            '&::before': {
              content: '""',
              position: 'absolute',
              inset: 0,
              padding: '1px',
              borderRadius: '50rem',
              background: 'linear-gradient(90deg, #0ff, rgba(10, 98, 116, 0))',
              WebkitMask:
                'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
              WebkitMaskComposite: 'xor',
              maskComposite: 'exclude',
              zIndex: -1,
              transition: 'opacity 0.3s ease',
            },
            '&:hover': {
              boxShadow:
                '0px -1px 3px rgba(255, 255, 255, 0.3), 0px 2px 10px rgba(0,0,0,0.5)',
              background:
                'linear-gradient(0deg, rgba(10, 98, 116, 0.5), rgba(10, 98, 116, 0.4))',
              '&::before': {
                opacity: 0,
              },
            },
          }}
        >Acerca de nosotros</Typography>}
        subtitle={
          <Box sx={{
            padding: { xs: "2rem 2rem", sm: "2.2rem 7.2rem" },
            textAlign: { sm: "justify" },
            width: '100%', marginBottom: '14vh'
          }}>
            <Typography sx={{ fontWeight: 500, fontSize: { xs: '12px', sm: '14px', md: '16px' }, textShadow: '0px 2px 10px rgb(0,0,0,0.5)', maxWidth: { sm: '450px', md: '600px' } }}>
              Conoce nuestro propósito, nuestro equipo, nuestra metodología y dónde encontrarnos.</Typography>
          </Box>
        }
        variant="bottom-left"
        section="about"
      />

      <Box sx={{
        backgroundImage: 'url(https://res.cloudinary.com/dhoyyqszi/image/upload/v1745947233/ebm/nosotros-background_hjvyie.png)',
        backgroundSize: 'cover',
      }}>
        <Grid container sx={{
          flexWrap: { xs: 'wrap-reverse', lg: 'wrap' }
        }}>
          <Grid item xs={12} lg={7.2} sx={{ display: 'flex', justifyContent: { xs: 'center', lg: 'flex-end' }, alignItems: { xs: 'center', lg: 'flex-end' }, mr: { xs: 0, lg: -2 }, ml: { xs: 0, lg: 2 } }}>
            <Box
              sx={{
                ml: { xs: 0, lg: 12 },
                maxWidth: { xs: '90%', lg: '710px' },
                height: 'auto',
                my: { xs: 5, lg: 0 },
                px: { xs: 4, lg: 8 },
                py: { xs: 4, lg: 6 },
                backdropFilter: "blur(12px)",
                backgroundColor: "linear-gradient(to right,rgb(0, 0, 0.0.2),rgb(0, 0, 0,0.3))",
                color: "white",
                transition: "all 0.3s ease",
                boxShadow: '0px 2px 10px rgba(0,0,0,0.4)',
                textAlign: 'justify',
                borderRadius: { xs: "12px", lg: "12px 0px 0px 12px" },
                '&::before': {
                  borderRadius: { xs: "12px", lg: "12px 0px 0px 12px" },
                  content: '""',
                  position: 'absolute',
                  inset: 0,
                  padding: '1px',
                  background: 'linear-gradient(90deg, #666666,rgba(0, 0, 0, 0))',
                  WebkitMask:
                    'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                  WebkitMaskComposite: 'xor',
                  maskComposite: 'exclude',
                  zIndex: -1,
                  transition: 'opacity 0.3s ease',
                },
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontSize: "16px",
                  "& strong": { fontWeight: 700 },
                }}
              >
                En <b>EBM</b> ofrecemos una <b>consultoría integral</b> dedicada a potenciar la familia, la empresa y el patrimonio. Nuestro compromiso es contribuir al desarrollo constante de quienes confían en nosotros, impulsando sus proyectos hacia la trascendencia.<br></br><br></br>
                Creemos en impulsar el desarrollo y fortalecer las bases para alcanzar objetivos sostenibles y significativos creando soluciones estratégicas mediante una metodología orientada a resultados y a optimizar toma de decisiones.<br></br><br></br>
                En EBM, consideramos que <b>el éxito de nuestros clientes es una meta compartida</b>, alcanzada a través de un enfoque multidisciplinario y visionario.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} lg={4.8} sx={{ mt: -8, display: 'flex', flexDirection: 'column', alignItems: { xs: 'center', lg: 'flex-end' }, zIndex: 1, position: 'relative' }}>
            <Typography
              sx={{
                position: 'absolute',
                top: '20px',
                left: '45%',
                right: { xs: '50%', lg: 0 },
                transform: { xs: 'translateX(50%)', lg: 'translateY(-150%)' },
                fontSize: { xs: '22px', md: '32px' },
                fontWeight: 800,
                color: '#FFFFFF',
                textTransform: 'uppercase',
                letterSpacing: 4,
                textAlign: 'center',
              }}
            >
              SOMOS
            </Typography>
            <Box
              sx={{
                width: '101%',
                maxWidth: { xs: '100%', md: '750px', lg: '635px' },
                mb: '-10px',
                mx: { xs: 'auto', lg: 0 },
                borderRadius: { xs: '0rem', lg: '50rem 0rem 0rem 50rem' },
                pr: { xs: 0, lg: 10 },
                py: 0.2,
                backdropFilter: "blur(10px)",
                background: "rgba(255,255,255,0.2)",
                color: "rgba(255,255,255,0.9)",
                fontWeight: 100,
                boxShadow: '2px 2px 10px rgba(0,0,0,0.4), -1px -1px 4px rgba(255,255,255,0.5)',
                fontSize: { xs: '24px', lg: '30px' },
                letterSpacing: 2,
                textAlign: { xs: 'center', lg: 'right' },
              }}
            >
              {frases[index].texto}
            </Box>

            <Box
              component="img"
              src={frases[index].imagen}
              sx={{
                width: '100%',
                height: '100%',
                maxWidth: { xs: 'auto', lg: '631px' },
                maxHeight: '400px',
                objectFit: 'cover',
              }}
            />
          </Grid>
        </Grid>

        <Grid container sx={{ justifyContent: 'center', flexDirection: { xs: 'column', md: 'row' }, alignItems: 'center', py: 8 }}>
          <Grid item sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
            <Box
              sx={{
                display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                mr: { xs: 0, lg: -0.2 },
                p: { xs: '40px', md: '4vw' },
                height: '330px',
                backdropFilter: "blur(12px)",
                background: 'linear-gradient(rgba(59, 128, 121,0.4), rgba(106, 229, 218,0))',
                color: "white",
                transition: "all 0.3s ease",
                boxShadow: '0px 2px 10px rgba(0,0,0,0.4)',
                textAlign: 'justify',
                borderRadius: "6rem 0px 0px 0px",
                '&::before': {
                  borderRadius: "6rem 0px 0px 0px",
                  content: '""',
                  position: 'absolute',
                  inset: 0,
                  padding: '1px',
                  background: { xs: 'linear-gradient(-90deg, rgba(59, 128, 121,1),rgba(59, 128, 121,0))', lg: 'linear-gradient(rgba(59, 128, 121,0),rgba(59, 128, 121,1))' },
                  WebkitMask:
                    'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                  WebkitMaskComposite: 'xor',
                  maskComposite: 'exclude',
                  zIndex: -1,
                  transition: 'opacity 0.3s ease',
                },
              }}
            >
              <Typography sx={{ letterSpacing: 2, color: '#D4A76A', fontSize: '32px', fontWeight: 700, textAlign: 'center' }}>MISIÓN</Typography>
              <Typography
                sx={{
                  maxWidth: '260px',
                  fontSize: "16px",
                }}
              >
                Acompañar a las familias empresarias y empresas familiares en su camino hacia el desarrollo y la trascendencia de su legado.
              </Typography>
            </Box>
          </Grid>
          <Grid item sx={{ display: { xs: 'none', lg: 'flex' }, alignItems: 'center' }}>
            <Box component='img' src={'https://res.cloudinary.com/dhoyyqszi/image/upload/v1745953890/ebm/mision-vision_bw1ecy.png'}
              sx={{
                width: '100%',
                height: '100%',
                maxWidth: '451px',
                maxHeight: '451px',
                objectFit: 'cover',
                borderRadius: { xs: 0, lg: '3rem 0rem 3rem 0rem' },
                zIndex: 1
              }}
            ></Box>
          </Grid>
          <Grid item sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
            <Box
              sx={{
                display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                mr: { xs: 0, lg: -0.1 },
                p: { xs: '40px', md: '4vw' },
                height: '330px',
                backdropFilter: "blur(12px)",
                background: { xs: 'linear-gradient(rgba(106, 229, 218,0), rgba(59, 128, 121,0.4) )', lg: 'linear-gradient(rgba(59, 128, 121,0.4), rgba(106, 229, 218,0))' },
                color: "white",
                transition: "all 0.3s ease",
                boxShadow: '0px 2px 10px rgba(0,0,0,0.4)',
                textAlign: 'justify',
                borderRadius: "0px 0px 6rem 0px ",
                '&::before': {
                  borderRadius: "0px 0px 6rem 0px ",
                  content: '""',
                  position: 'absolute',
                  inset: 0,
                  padding: '1px',
                  background: { xs: 'linear-gradient(90deg, rgba(59, 128, 121,1),rgba(59, 128, 121,0))', lg: 'linear-gradient(rgba(59, 128, 121,0),rgba(59, 128, 121,1))' },
                  WebkitMask:
                    'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                  WebkitMaskComposite: 'xor',
                  maskComposite: 'exclude',
                  zIndex: -1,
                  transition: 'opacity 0.3s ease',
                },
              }}
            >
              <Typography sx={{ letterSpacing: 2, color: '#D4A76A', fontSize: '32px', fontWeight: 700, textAlign: 'center' }}>VISIÓN</Typography>
              <Typography
                sx={{
                  maxWidth: '260px',
                  fontSize: "16px",
                }}
              >
                Transformar la cultura empresarial de las familias hacia la profesionalización y sostenibilidad.
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>

      <Box>
        <MetodoCircularMUI />
      </Box>

      {/* Equipo */}
      <Box sx={{ textAlign: 'center', mb: 4, px: 2 }}>
        <Typography
          variant="h5"
          sx={{
            color: '#38383D',
            fontFamily: 'Poppins, sans-serif',
            letterSpacing: '8px',
            fontWeight: 800,
            fontSize: { xs: '20px', md: '32px' },
            mt: { xs: 4, md: '90px' },
          }}
        >
          NUESTRO EQUIPO
        </Typography>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '29px',
            px: 3,
            borderRadius: '1000px',
            position: 'relative',
            fontFamily: 'Poppins, sans-serif',
            fontWeight: 600,
            fontSize: '14px',
            color: '#000',
            lineHeight: 1,
            textAlign: 'center',
            maxWidth: 'fit-content',
            mx: 'auto',
            mt: 2,
            zIndex: 0,
            background: 'linear-gradient(to bottom, #E0F4F3 0%, #B0DAD7 100%)',
            boxShadow: '0 8px 12px rgba(91, 199, 189, 0.45)',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              borderRadius: '1000px',
              padding: '1px',
              background: 'linear-gradient(to right, #5BC7BD, rgba(91, 199, 189, 0))',
              zIndex: -1,
              WebkitMask:
                'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
              WebkitMaskComposite: 'xor',
              maskComposite: 'exclude',
            },
          }}
        >
          <Typography
            sx={{
              fontFamily: 'Poppins, sans-serif',
              fontSize: { xs: '14px', md: '18px' },
              fontWeight: 400,
              color: '#111',
              textAlign: 'center',
              '& b': { fontWeight: 700 },
            }}
          >
            Líderes comprometidos con <b>tu éxito</b>

          </Typography>
        </Box>
      </Box>
      <Box sx={{ backgroundColor: '#f7f7f7', py: { xs: 2, md: 4 }, position: 'relative' }}>
        {/* Name banner for Enrique (outside the carousel) */}
        <Box
          sx={{
            position: 'absolute',
            top: { xs: '50px', md: '130px' },
            left: { xs: '50%', md: `calc(50% + ${1238 / 2}px - 548px * 0.6)` },
            width: { xs: 'calc(100% - 32px)', md: '548px', xl: '600px' },
            height: { xs: '30px', md: '44px' },
            px: 3,
            background: 'linear-gradient(90deg, #0A6274 0%, #13B8DA 100%)',
            color: 'white',
            fontFamily: 'Poppins, sans-serif',
            fontWeight: 'bold',
            fontSize: { xs: '18px', md: '30px' },
            textTransform: 'uppercase',
            display: 'flex',
            alignItems: 'center',
            justifyContent: { xs: 'center', md: 'flex-start' },
            borderRadius: { xs: '30px', md: '30px' },
            zIndex: 3,
            transform: { xs: 'translateX(-50%)', md: 'translateX(-30%)' },
            visibility: 'hidden',
            letterSpacing: 5,
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.4), 0px 0px 20px rgba(255, 255, 255, 0.3)',
          }}
          id="enrique-name-banner"
        >
          Enrique Barrera
        </Box>

        {/* Name banner for Erika (outside the carousel) */}
        <Box
          sx={{
            position: 'absolute',
            top: { xs: '50px', md: '130px' }, // Same top as Enrique's banner
            left: { xs: '50%', md: `calc(50% + ${1238 / 2}px - 548px * 0.6)` }, // Same left as Enrique's banner
            width: { xs: 'calc(100% - 32px)', md: '548px', xl: '600px' },
            height: { xs: '30px', md: '44px' },
            px: 3,
            background: 'linear-gradient(90deg, #0A6274 0%, #13B8DA 100%)',
            color: 'white',
            fontFamily: 'Poppins, sans-serif',
            fontWeight: 'bold',
            fontSize: { xs: '18px', md: '30px' },
            textTransform: 'uppercase',
            display: 'flex',
            alignItems: 'center',
            justifyContent: { xs: 'center', md: 'flex-start' },
            borderRadius: { xs: '30px', md: '30px' },
            zIndex: 3,
            transform: { xs: 'translateX(-50%)', md: 'translateX(-30%)' },
            visibility: 'hidden',
            letterSpacing: 5,
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.4), 0px 0px 20px rgba(255, 255, 255, 0.3)',

          }}
          id="erika-name-banner"
        >
          Erika Ibarra
        </Box>

        {/* Name banner for Edwin (outside the carousel) */}
        <Box
          sx={{
            position: 'absolute',
            top: { xs: '50px', md: '130px' },
            left: { xs: '50%', md: `calc(50% + ${1238 / 2}px - 548px * 0.6)` },
            width: { xs: 'calc(100% - 32px)', md: '548px', xl: '600px' },
            height: { xs: '30px', md: '44px' },
            px: 3,
            background: 'linear-gradient(90deg, #0A6274 0%, #13B8DA 100%)',
            color: 'white',
            fontFamily: 'Poppins, sans-serif',
            fontWeight: 'bold',
            fontSize: { xs: '18px', md: '30px' },
            textTransform: 'uppercase',
            display: 'flex',
            alignItems: 'center',
            justifyContent: { xs: 'center', md: 'flex-start' },
            borderRadius: { xs: '30px', md: '30px' },
            zIndex: 3,
            transform: { xs: 'translateX(-50%)', md: 'translateX(-30%)' },
            visibility: 'hidden',
            letterSpacing: 5,
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.4), 0px 0px 20px rgba(255, 255, 255, 0.3)',
          }}
          id="edwin-name-banner"
        >
          Edwin Ruiz
        </Box>

        {/* Carrusel equipo */}
        <CarouselUs/>

        {/* Banner equipo */}
        <Box
          sx={{
            width: '100%',
            maxWidth: '1238px',
            backgroundColor: '#1a1a1a',
            margin: '20px auto',
            borderRadius: 4,
            padding: 2,
            overflowX: isMobile ? 'scroll' : 'hidden',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: isMobile ? 'flex-start' : 'space-evenly',
            gap: 2,
            scrollSnapType: isMobile ? 'x mandatory' : 'none',
            '& > *': {
              scrollSnapAlign: 'start',
            },
          }}
        >
          {equipo.map((persona, index) => (
            <Box key={index} sx={{ textAlign: 'center', color: 'white', minWidth: isMobile ? '200px' : 'auto' }}>
              <Avatar
                src={persona.img}
                alt={persona.nombre}
                sx={{
                  width: '177px',
                  height: '241px',
                  borderRadius: '5px',
                  marginBottom: 1,
                  mx: 'auto',
                }}
                variant="rounded"
              />
              <Typography variant="body1" fontWeight="bold">{persona.nombre}</Typography>
              <Typography variant="body2">{persona.titulo}</Typography>
            </Box>
          ))}
        </Box>
      </Box>
      {/* Sección: Encuéntranos con mapa */}
      <Box sx={{
        position: 'relative',
        width: '100%',
        height: { xs: '300px', sm: '400px' },
        mt: 6
      }}>
        {/* Mapa */}
        <Box
          component="iframe"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3486.4776876310966!2d-110.96314042674359!3d29.091575608777443!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x86ce843130c8ec47%3A0x780a6bbbe744ea74!2sBR%20Consultores!5e0!3m2!1ses-419!2smx!4v1747696890539!5m2!1ses-419!2smx"
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          sx={{
            border: 0,
            width: '100%',
            height: '100%',
            filter: 'grayscale(100%)',
          }}
        />

        {/* Tarjeta encima del mapa */}
        <Box
          sx={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: { xs: '100%', sm: '519px' },
            height: { xs: 'auto', sm: '181px' },
            background: 'linear-gradient(0deg, rgba(59, 127, 121, 1) 0%, rgba(59, 127, 121, 0.5) 100%)',
            color: 'white',
            borderTopRightRadius: { xs: '0', sm: '80px' },
            padding: { xs: '16px', sm: '24px' },
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)',
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.3)',
            border: '0.8px solid rgba(255, 255, 255, 0.2)',
            pl: { xs: '20px', sm: '60px' },
          }}
        >
          <Typography sx={{
            fontWeight: 'bold',
            fontSize: { xs: '24px', sm: '36px' },
            mb: 1
          }}>
            ENCUÉNTRANOS
          </Typography>
          <Typography sx={{
            fontWeight: 'regular',
            fontSize: { xs: '14px', sm: '16px' },
            mb: 1
          }}>
            Pacheco 19, San Benito, 83190 Hermosillo, Son.
          </Typography>
        </Box>
      </Box>

        {/* Carrusel con artículos de WordPress */}
           <Box sx={{ 
             backgroundColor: 'white', 
             pb: 10, 
             pt: 8, 
             display: 'flex', 
             justifyContent: 'center', 
             flexDirection: 'column', 
             alignItems: 'center', 
             borderBottom: '1px solid #E0E0E0' 
           }}>
             <Typography sx={{ 
               py: 4, 
               color: '#0A6274', 
               fontSize: { xs: '1.6rem', md: '2rem' }, 
               fontWeight: 600, 
               textAlign: 'center' 
             }}>
               Explora nuestros <b>últimos insights</b>
             </Typography>
             
             {isLoadingArticles ? (
               <Box sx={{ height: '300px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                 <CircularProgress color="primary" />
               </Box>
             ) : wordpressArticles.length > 0 ? (
               <CarouselArticulos wpData={wordpressArticles} />
             ) : (
               <Typography>No hay artículos disponibles</Typography>
             )}
           </Box>

    </Container >
    </>
  );
}